export default __webpack_public_path__ + "static/media/1989.e1502a90.png";